import { Routes } from '@angular/router';
import { ResourceGuard } from 'app/core/routeGuards/resource.guard';
import { EPermissionOption, EUserType } from 'app/store/auth/model/models';

export const Tech_Routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./dlq/dlq.module').then(m => m.DlqModule),
    canActivate: [ResourceGuard],
    data: {
      aclResource: '/tech/dlq/messages',
      aclAccessLevel: EPermissionOption.ReadOnly,
      aclUserType: EUserType.Internal,
    },
  }
]
